import React from "react";
import StyledTooltip from "../../common/StyledTooltip";

export default function FinancialIncomeCard({ data }) {
  const breakdown = [
    {
      label: "Principal",
      value: data?.financialBreakdown?.principal?.display || "₹0",
      originalValue: data?.financialBreakdown?.principal?.amount || 0,
    },

    {
      label: "Interest",
      value: data?.financialBreakdown?.interest?.display || "₹0",
      originalValue: data?.financialBreakdown?.interest?.amount || 0,
    },

    {
      label: "Processing Fee",
      value: data?.financialBreakdown?.processingFee?.display || "₹0",
      originalValue: data?.financialBreakdown?.processingFee?.amount || 0,
    },

    {
      label: "Charges",
      value: data?.financialBreakdown?.charges?.display || "₹0",
      originalValue: data?.financialBreakdown?.charges?.amount || 0,
    },
  ];
  const totalAmount =
    (data?.financialBreakdown?.principal?.amount || 0) +
    (data?.financialBreakdown?.interest?.amount || 0) +
    (data?.financialBreakdown?.processingFee?.amount || 0) +
    (data?.financialBreakdown?.charges?.amount || 0);

  const totalDisplay = `₹${(totalAmount / 100000)?.toFixed(2)}L`;

  return (
    <>
      <div style={{ marginTop: "40px" }}>
        <h4 style={{ color: "#0A0A0A", fontWeight: "600", fontSize: "20px" ,  }}>
          Financial Summary & MIS
        </h4>
        <p style={{ color: "#4A5565", fontSize: "14px", fontWeight: "400" }}>
          Month: {data?.month || "-"}
        </p>
      </div>
      <div
        style={{
          width: "100%",
          margin: "24px auto",
          background: "linear-gradient(175deg, #155DFC 0%, #9810FA 100%)",
          borderRadius: "10px",
          padding: "32px",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          position: "relative",
          overflow: "hidden",
        }}
      >
        <div
          style={{
            position: "absolute",
            right: "40px",
            top: "50%",
            transform: "translateY(-50%)",
            opacity: 0.2,
          }}
        >
          <svg
            width="80"
            height="80"
            viewBox="0 0 24 24"
            fill="none"
            stroke="#ffffff"
            strokeWidth="1.5"
          >
            <line x1="12" y1="1" x2="12" y2="23" />
            <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" />
          </svg>
        </div>

        <div>
          <h6
            style={{
              margin: '0px 0px 10px 0px',
              color: "#FFFFFF",
   fontSize: window.innerWidth >= 1800 ? "18px" : "12px",
              fontWeight: "400",
            }}
          >
            Total Financial Income
          </h6>

          <StyledTooltip value={totalAmount}>
            <h6
              style={{
                margin: "0px 0 0 0",
                fontSize: window.innerWidth >= 1800 ? "26px" : "16px",
                fontWeight: "700",
                color: "#ffffff",
                letterSpacing: "-1px",
              }}
            >
              {totalDisplay}
            </h6>
          </StyledTooltip>
        </div>

        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(4, 1fr)",
            marginTop: "20px",
          }}
        >
          {breakdown && breakdown?.length > 0 && breakdown?.map((item, idx) => (
            <div key={idx}>
              <h6
                style={{
                  margin: 0,
                  fontSize: window.innerWidth >= 1800 ? "16px" : "12px",
                  color: "#FFFFFF",
                  fontWeight: "400",
                }}
              >
                {item.label}
              </h6>

              <StyledTooltip value={item.originalValue}>
                <h6
                  style={{
                    marginTop: "6px",
                    fontSize: window.innerWidth >= 1800 ? "26px" : "16px",
                    fontWeight: "700",
                    color: "#ffffff",
                    marginBottom: "0",
                  }}
                >
                  {item.value}
                </h6>
              </StyledTooltip>
            </div>
          ))}
        </div>
      </div>
    </>
  );
}
